<template>
    <div class="gc-bglayer"
         v-bind:class="[{ 'gc-active': layer.isVisible, 'gc-void-layer': layer.isVoid }, layer.previewClassName]"
         v-bind:style="{ 'background-image': (layer.previewImage ? 'url(' + layer.previewImage + ')' : undefined) }"
         v-on:click="$emit('selectLayer', layer)"
         v-bind:title="layer.abstract ? layer.abstract : layer.label"
    >
        <span>{{ layer.label }}</span>
    </div>
</template>

<script>
    export default {
        name: "LayerListItem",
        props: {
            layer: {
                type: Object,
                required: true
            }
        },
        mounted: function() {
            this.$nextTick(function () {
                gc.gis.iface.ui.tooltip(this.$el, {
                    placement: 'auto top'
                });
            })
        }
    }
</script>
